var map = {
	"./arabian-woman-overlay.jpg": 1630,
	"./arabian-woman.jpg": 614,
	"./background-1.jpg": 2654,
	"./busines-strategy.jpg": 9044,
	"./environment.jpg": 5079,
	"./mills-over-field.jpg": 4643,
	"./our-commitments-header-image.jpg": 2625,
	"./our-esg-strategy.jpg": 7601,
	"./people-taking-overlay.jpg": 3290,
	"./people-talking.jpg": 4194,
	"./saudi-green-initiative.jpg": 169,
	"./shore-woods-sea.jpg": 1029,
	"./solar-panels-header-image.jpg": 6185,
	"./sustainable-project.jpg": 1068,
	"./transition-to-net-zero.jpg": 3334,
	"./vision-background.jpg": 4437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1330;